import { Routes } from '@angular/router';

/**
 * Route area Configurations. Di-spread di `main-layout.routes.ts` TANPA segmen prefix karena menu
 * BE mengarah langsung ke `admin/configurations` — sidebar memakai `navigable.path` apa adanya
 * sebagai `routerLink`. `title` memakai key i18n (I18nTitleStrategy).
 */
export const configurationsRoutes: Routes = [
  {
    path: 'configurations',
    loadComponent: () =>
      import('./pages/configurations-list/configurations').then((c) => c.ConfigurationsComponent),
    title: 'configuration.title',
  },
];
